//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
        }
    },
    computed: {
    },
    onLoad (options) {
    },
    onPullDownRefresh () {
    },
    onReachBottom () {
    },
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/packageA/contact_us/main')
        return this.getShareInfo({
            title: `联系我们`,
            path: `/pages/index/main?sub_page=${sub_page}`,
        })
    },
    methods: {
    },
    components: {
    }
}
